<template>
  <div>
    <div class="table-wrapper" :data-style="blok.style || 'default'">
      <h3 v-if="blok.title" v-html="blok.title" class="table-title"></h3>
      <table ref="table" table v-editable="blok">
        <thead v-if="hasHeader">
          <tr>
            <th v-for="(thead, th) in blok.table.thead" :key="th" v-text="thead.value"></th>
          </tr>
        </thead>
        <tbody v-if="blok.table.tbody.length">
          <tr v-for="(row, r) in blok.table.tbody" :key="r">
            <template v-if="blok.is_markdown">
              <td v-for="(col, c) in row.body" :key="c">
                <MDC :value="col.value" tag="" />
              </td>
            </template>
            <template v-else>
              <td v-for="(col, c) in row.body" :key="c" v-html="parseCell(col.value)"></td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-footer" v-if="blok?.footer && footer != ''" v-html="footer"></div>
    <div class="table-buttons flex justify-center mb-10" v-if="blok?.buttons">
      <StoryblokComponent v-for="blok in blok.buttons" :key="blok._uid" :blok="blok" />
    </div>
  </div>
</template>
<style src="~/assets/scss/section/table.scss" lang="scss"></style>
<script setup>
const props = defineProps({ blok: Object });

const footer = computed(() => useRichText(props.blok?.footer));

const hasHeader = computed(() => {
  if (props.blok.table.thead.length === 0) return false;
  return (
    props.blok.table.thead
      .map((th) => th.value)
      .join("")
      ?.replace(/(<([^>]+)>)/gi, "")
      ?.trim()?.length > 0
  );
});

const table = ref();

onMounted(() => {
  const tableEl = table.value;

  for (const row of tableEl.rows) {
    let currentCell = row.cells[0];
    let nextCell = row.cells[1];

    for (let i = 1; i < row.cells.length; i++) {
      nextCell = row.cells[i];
      if (currentCell.textContent === nextCell.textContent) {
        if (!currentCell.innerHTML.includes("btn")) return;
        currentCell.colSpan += 1;
        row.removeChild(nextCell);
      } else {
        currentCell = nextCell;
      }
    }
  }
});

const parseCell = (string) => {
  string = string.replaceAll("\n", "<br />");
  return string;
};
</script>
